import { TYPES } from '../../common/constants';

export const setAssetFormData = payload => ({
  type: TYPES.SET_ASSET_FORM_DATA,
  payload,
});

export const clearAssetFormData = () => ({
    type:TYPES.CLEAR_ASSET_FORM_DATA,
})